import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { Button, useIsMounted } from 'seagull';
import { GoogleIcon } from 'seagull/icons';
import { useIoContext } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
export function NativeGoogleButton(param) {
    let { width, clientId, scopes, onCredential, onError } = param;
    const { t } = useLocaleKeys('pages.auth');
    const { nativeGoogleAuth } = useIoContext();
    const [loading, setLoading] = useState(false);
    const isMounted = useIsMounted();
    async function handleClick() {
        if (loading) return;
        setLoading(true);
        let response = null;
        try {
            response = await nativeGoogleAuth.signIn({
                clientId,
                scopes
            });
        } catch (error) {
            if (isMounted()) {
                onError(error);
            }
        } finally{
            if (isMounted()) {
                setLoading(false);
            }
        }
        if (response != null && isMounted()) {
            onCredential(response);
        }
    }
    return /*#__PURE__*/ _jsx(Button, {
        testId: "native-google-login",
        bi: {
            name: 'native_google_signin'
        },
        skin: "primaryOutline",
        onClick: handleClick,
        disabled: loading,
        prefixIcon: /*#__PURE__*/ _jsx(GoogleIcon, {
            size: 18
        }),
        style: width != null ? {
            width
        } : undefined,
        children: t.continueWithGoogle()
    });
}
